import { IDownloadFile } from '@api/models/files'
import api from '../index'
import { AxiosRequestConfig } from 'axios'

export const uploadFile = (data: FormData, config?: AxiosRequestConfig) => {
  return api.post('/files', data, config)
}

export type IframePackageUploadResponse = {
  fileId: string
  iframeUrl: string
  zipUrl: string
}

export const uploadIframePackage = (
  file: File,
  unitId?: string,
  temporary?: boolean,
  config?: AxiosRequestConfig
) => {
  const formData = new FormData()
  formData.append('file', file)

  if (unitId) {
    formData.append('unitId', unitId)
  }

  if (typeof temporary === 'boolean') {
    formData.append('temporary', String(temporary))
  }

  return api.post<IframePackageUploadResponse>(
    '/files/iframe-package',
    formData,
    {
      ...config,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...config?.headers
      }
    }
  )
}

function base64ToUint8Array(base64: string): Uint8Array {
  const binary = atob(base64)
  const len = binary.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

function extensionFromMime(mime: string | undefined): string {
  if (!mime) return 'png'
  const map: Record<string, string> = {
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/gif': 'gif',
    'image/webp': 'webp'
  }
  return map[mime.toLowerCase()] ?? 'png'
}

/**
 * Decodes a raw base64 image payload, uploads it as multipart `file` to POST /files,
 * and returns the stored URL/path from the API (same contract as DynamicFileInput).
 */
export async function uploadBase64Image(
  base64: string,
  mimeType?: string
): Promise<string> {
  const bytes = base64ToUint8Array(base64)
  const type = mimeType || 'image/png'
  const ext = extensionFromMime(type)
  const blob = new Blob([bytes], { type })
  const file = new File([blob], `generated.${ext}`, { type })
  const data = new FormData()
  data.append('file', file)
  const response = await uploadFile(data)
  const path = response.data?.path
  if (!path || typeof path !== 'string') {
    throw new Error('Upload response missing path')
  }
  return path
}
export const downloadFile = (data: IDownloadFile) => {
  return api.post('/files/downloads', data)
}
